import React from 'react';
import { CardContent } from '../../../../components/ui/card';
import { ScrollArea } from '../../../../components/ui/scroll-area';
import CollapsibleCard from '../../../../components/CollapsibleCard';
import constants from '../../../../commonUtils/constants';

const getItemClass = (index, length) => {
    if (index === 0 || index === length - 1) {
        return 'col-span-1 lg:col-span-3';
    }
    if (index === 2) {
        return 'col-span-1 lg:col-span-2';
    }
    return 'col';
};

const Title = ({title}) => {
    return (
        <div className='flex items-center'>
            {/* <IconButton
                variant="iconsm"
                className="p-0 m-0 pr-2"
                Icon={ChevronLeftIcon}
                onClick={() => navigate('/upload-history')}
            /> */}
            <span>{title}</span>
        </div>
    )
};

const ReviewFormData = ({ viewBackButton = false, reviewFormData, data }) => {
    
    const safeData = data || {};
    const safeFile = safeData.file || {};
    const safeReviewFormData = reviewFormData || [];
    
    return (
        <>
            <CollapsibleCard 
                title={
                    safeData.pending || viewBackButton ? 
                    <Title title={safeFile?.name || safeFile?.original_name || ""}/> : 
                    "Meta Data"
                } 
                showCollapseButton={true}
            >
                <ScrollArea style={{ height: constants.upload.cardHeight }}>
                    <CardContent className="flex flex-col gap-4">
                        <p className="leading-4 border-b border-primary pb-3 font-bold">Upload Data</p>
                        <div className="grid grid-cols-1 lg:grid-cols-3">
                            {safeReviewFormData.map((item, index) => (
                                <p
                                    key={index}
                                    className={`leading-2 mb-2 md:mb-4 ${getItemClass(index, safeReviewFormData.length)}`}
                                >
                                    <span className="font-semibold">{item.label}</span> {item.value || 'N/A'}
                                </p>
                            ))}
                        </div>

                        <p className="leading-4 border-b border-primary pb-3 font-bold">File Data</p>
                        {safeFile?.name || safeFile?.unique_name || safeFile?.original_name ? (
                            <div className="grid grid-cols-1">
                                <p className={`col leading-2 mb-2 md:mb-4`}>
                                    <span className="font-semibold">File Name:</span> {safeFile?.name || safeFile?.original_name || ""}
                                </p>
                                <p className={`col leading-2 mb-2 md:mb-4`}>
                                    <span className="font-semibold">File Size:</span> {safeFile?.sizeInMB || 'N/A'} MB
                                </p>
                                <p className={`col leading-2 mb-2 md:mb-4`}>
                                    <span className="font-semibold">Rows: </span> {safeFile?.rowCount?.toLocaleString() || 'N/A'}
                                </p>
                                <p className={`col leading-2 mb-2 md:mb-4`}>
                                    <span className="font-semibold">Columns: </span> {safeFile?.colCount || 'N/A'}
                                </p>
                            </div>
                        ) : (
                            <div className="grid grid-cols-1">
                                <span className='text-muted-foreground'>No File Uploaded</span>
                            </div>
                        )}
                    </CardContent>
                </ScrollArea>
            </CollapsibleCard>
        </>
    );
};

export default ReviewFormData;